import Guest from '@/layouts/guest';
import React, {useEffect, useState} from 'react';
import {Container, Row} from "react-bootstrap";
import {useParams} from "react-router-dom";
import PostDetailsSidebar from "@/components/global/posts/details-sidebar";
import PostPlayer from "@/components/global/posts/player";
import PostDescription from "@/components/global/posts/description";
import PostComments from "@/components/global/posts/comments";
import PostsSimilars from "@/components/global/posts/similars";
import PostsService from "@/services/posts-service";
import {ALERT} from "@/actions/types";
import {useDispatch} from "react-redux";
import Loader from "@/components/global/loader";
import { setCanonical } from '@/app/general';

const Details: React.FC = (props: any) => {
    const params = useParams();
    const [loading, setLoading] = useState(true);
    const [post, setPost] = useState<IPostDetails | null>(null);
    const [relatedPosts, setRelatedPosts] = useState<IPostItem[]>([]);
    const dispatch = useDispatch();

    useEffect(() => {
        // get post based on slug
        if(params.slug) PostsService.getPost(params.slug || '').then(({post, related_posts}: { post: IPostDetails, related_posts: IPostItem[] }) => {
            setPost({...post});
            setRelatedPosts(related_posts);
        }).catch((err: any) => {
            dispatch({
                type: ALERT,
                payload: { message: { result: 0, message: 'دریافت آگهی موردنظر با خطا مواجه شد. لطفا صفحه را رفرش نمایید!' } }
            });
        }).finally(() => {
            setLoading(false);
        });
    }, [dispatch, params.slug]);

    useEffect(() => {
        if(post?.id) {
            setCanonical(`https://${document.location.hostname}/post/${post.id}`);
        }
    }, [post?.id]);

    return (
        <Guest title={post?.title || "جزئیات آگهی"}>
            {loading ? <div className="container-fluid p-5"><Loader /></div> : (
                <>
                    <Container className="py-5">
                        <Row>
                            <div className="col-lg-3 mb-lg-0 mb-4">
                                <PostDetailsSidebar post={post} />
                            </div>
                            <div className="col-lg-9">
                                {post?.files.map(file => (
                                    <React.Fragment key={'file' + file.fileSrc + Math.random()}>
                                        {file.isPlayable ? (
                                            <PostPlayer file={file} />
                                        ) : (file.isDownloadable ? <div className="text-center my-3">
                                            <a href={file.fileSrc} className="btn btn-success" download>
                                                <i className="fa fa-download" /> دانلود {file.title}
                                            </a>
                                        </div> : '')}
                                    </React.Fragment>
                                ))}
                                <PostDescription post={post} />

                                <PostComments comments={post?.comments} postId={post?.id || 0} />
                            </div>
                        </Row>

                        <PostsSimilars posts={relatedPosts} />
                    </Container>
                </>
            )}
        </Guest>
    );
}

export default Details;
